import { CreditCard as r } from "./credit-card.js";
import { CreditCard2 as o } from "./credit-card-2.js";
import { CreditCardCheck as i } from "./credit-card-check.js";
import { CreditCardLock as m } from "./credit-card-lock.js";
import { Cash as a } from "./cash.js";
import { Giftcard as t } from "./giftcard.js";
import { Giftcard2 as n } from "./giftcard-2.js";
import { Issuing as p } from "./issuing.js";
import { StackOfCreditCards2 as f } from "./stack-of-credit-cards-2.js";
import { StackOfCreditCards as e } from "./stack-of-credit-cards.js";
import { InstantCardPayout as l } from "./instant-card-payout.js";
import { Payout as C } from "./payout.js";
import { FastPayout as c } from "./fast-payout.js";
import { CashStack as u } from "./cash-stack.js";
import { Wallet as s } from "./wallet.js";
import { Graph as d } from "./graph.js";
import { Revenue as h } from "./revenue.js";
import { Graph2 as y } from "./graph-2.js";
import { PricingCards as g } from "./pricing-cards.js";
import { CreditCardChip as D } from "./credit-card-chip.js";
import { Installments as S } from "./installments.js";
import { MagnetStripSwipe as K } from "./magnet-strip-swipe.js";
import { CashBack as R } from "./cash-back.js";
import { Passport as P } from "./passport.js";
import { Euro as V } from "./euro.js";
import { CzechKoruna as w } from "./czech-koruna.js";
import { IcelandicKrona as k } from "./icelandic-krona.js";
import { DanishKrone as M } from "./danish-krone.js";
import { NorwegianKrone as b } from "./norwegian-krone.js";
import { SwedishKrona as G } from "./swedish-krona.js";
import { PolishZloty as I } from "./polish-zloty.js";
import { RussianRuble as z } from "./russian-ruble.js";
import { SwissFranc as A } from "./swiss-franc.js";
import { WestAfricanCfaFranc as B } from "./west-african-cfa-franc.js";
import { PoundSterling as F } from "./pound-sterling.js";
import { HungarianForint as N } from "./hungarian-forint.js";
import { ChineseYuanRenminbi as O } from "./chinese-yuan-renminbi.js";
import { HongKongDollar as E } from "./hong-kong-dollar.js";
import { IndianRupee as T } from "./indian-rupee.js";
import { IndonesianRupiah as U } from "./indonesian-rupiah.js";
import { JapaneseYen as W } from "./japanese-yen.js";
import { MalaysianRinggit as Z } from "./malaysian-ringgit.js";
import { NewZealandDollar as x } from "./new-zealand-dollar.js";
import { PhilippinePeso as H } from "./philippine-peso.js";
import { SingaporeDollar as L } from "./singapore-dollar.js";
import { SouthKoreanWon as Q } from "./south-korean-won.js";
import { ThaiBaht as Y } from "./thai-baht.js";
import { VietnameseDong as v } from "./vietnamese-dong.js";
import { BrazilianReal as J } from "./brazilian-real.js";
import { MexicanPeso as j } from "./mexican-peso.js";
import { UnitedStatesDollar as q } from "./united-states-dollar.js";
import { CanadianDollar as X } from "./canadian-dollar.js";
import { AustralianDollar as _ } from "./australian-dollar.js";
import { GhanaianCedi as $ } from "./ghanaian-cedi.js";
import { TanzanianShilling as rr } from "./tanzanian-shilling.js";
import { UgandanShilling as or } from "./ugandan-shilling.js";
import { KenyanShilling as ir } from "./kenyan-shilling.js";
import { ZambianKwacha as mr } from "./zambian-kwacha.js";
import { MozambicanMetical as ar } from "./mozambican-metical.js";
import { MoroccanDirham as tr } from "./moroccan-dirham.js";
import { NigerianNaira as nr } from "./nigerian-naira.js";
import { BahrainiDinar as pr } from "./bahraini-dinar.js";
import { EgyptianPound as fr } from "./egyptian-pound.js";
import { KuwaitiDinar as er } from "./kuwaiti-dinar.js";
import { OmaniRial as lr } from "./omani-rial.js";
import { QatariRiyal as Cr } from "./qatari-riyal.js";
import { SaudiArabianRiyal as cr } from "./saudi-arabian-riyal.js";
import { UaeDirham as ur } from "./uae-dirham.js";
import { CurrencyAustralianDollar as sr } from "./currency-australian-dollar.js";
import { CurrencyBahrainiDinarV2 as dr } from "./currency-bahraini-dinar-v2.js";
import { CurrencyCzechKoruna as hr } from "./currency-czech-koruna.js";
import { CurrencyDanishKrone as yr } from "./currency-danish-krone.js";
import { CurrencyEgyptianPoundV2 as gr } from "./currency-egyptian-pound-v2.js";
import { CurrencyGeneric as Dr } from "./currency-generic.js";
import { CurrencyKuwaitiDinarV2 as Sr } from "./currency-kuwaiti-dinar-v2.js";
import { CurrencyMoroccanDirhamV2 as Kr } from "./currency-moroccan-dirham-v2.js";
import { CurrencyOmaniV2 as Rr } from "./currency-omani-v2.js";
import { CurrencyQatariRiyalV2 as Pr } from "./currency-qatari-riyal-v2.js";
import { CurrencySaudiArabianRiyalV2 as Vr } from "./currency-saudi-arabian-riyal-v2.js";
import { TurkishLira as wr } from "./turkish-lira.js";
import { VirtualCard as kr } from "./virtual-card.js";
const oi = {
  CreditCard: r,
  CreditCard2: o,
  CreditCardCheck: i,
  CreditCardLock: m,
  Cash: a,
  Giftcard: t,
  Giftcard2: n,
  Issuing: p,
  StackOfCreditCards2: f,
  StackOfCreditCards: e,
  InstantCardPayout: l,
  Payout: C,
  FastPayout: c,
  CashStack: u,
  Wallet: s,
  Graph: d,
  Revenue: h,
  Graph2: y,
  PricingCards: g,
  CreditCardChip: D,
  Installments: S,
  MagnetStripSwipe: K,
  CashBack: R,
  Passport: P,
  Euro: V,
  CzechKoruna: w,
  IcelandicKrona: k,
  DanishKrone: M,
  NorwegianKrone: b,
  SwedishKrona: G,
  PolishZloty: I,
  RussianRuble: z,
  SwissFranc: A,
  WestAfricanCfaFranc: B,
  PoundSterling: F,
  HungarianForint: N,
  ChineseYuanRenminbi: O,
  HongKongDollar: E,
  IndianRupee: T,
  IndonesianRupiah: U,
  JapaneseYen: W,
  MalaysianRinggit: Z,
  NewZealandDollar: x,
  PhilippinePeso: H,
  SingaporeDollar: L,
  SouthKoreanWon: Q,
  ThaiBaht: Y,
  VietnameseDong: v,
  BrazilianReal: J,
  MexicanPeso: j,
  UnitedStatesDollar: q,
  CanadianDollar: X,
  AustralianDollar: _,
  GhanaianCedi: $,
  TanzanianShilling: rr,
  UgandanShilling: or,
  KenyanShilling: ir,
  ZambianKwacha: mr,
  MozambicanMetical: ar,
  MoroccanDirham: tr,
  NigerianNaira: nr,
  BahrainiDinar: pr,
  EgyptianPound: fr,
  KuwaitiDinar: er,
  OmaniRial: lr,
  QatariRiyal: Cr,
  SaudiArabianRiyal: cr,
  UaeDirham: ur,
  CurrencyAustralianDollar: sr,
  CurrencyBahrainiDinarV2: dr,
  CurrencyCzechKoruna: hr,
  CurrencyDanishKrone: yr,
  CurrencyEgyptianPoundV2: gr,
  CurrencyGeneric: Dr,
  CurrencyKuwaitiDinarV2: Sr,
  CurrencyMoroccanDirhamV2: Kr,
  CurrencyOmaniV2: Rr,
  CurrencyQatariRiyalV2: Pr,
  CurrencySaudiArabianRiyalV2: Vr,
  TurkishLira: wr,
  VirtualCard: kr
};
export {
  oi as Financial
};
